import { render, staticRenderFns } from "./NotificacoesAdministrativas.vue?vue&type=template&id=8639fb46&scoped=true&"
import script from "./NotificacoesAdministrativas.vue?vue&type=script&lang=js&"
export * from "./NotificacoesAdministrativas.vue?vue&type=script&lang=js&"
import style0 from "./NotificacoesAdministrativas.vue?vue&type=style&index=0&id=8639fb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8639fb46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDataTable,VIcon,VRow,VTooltip})
